import { Injectable } from '@angular/core';

/**
 * PosConfigSettingsService (Angular 18)
 *
 * Ported 1:1 from apps/b2b-ui/common/services/posConfig/posConfigSettings/posConfigSettings.service.js
 * (legacy name 'PosConfigSettingsService'). Holds the POS settings model.
 * Internal sub-service of PosConfigService — injected directly, not
 * downgrade-registered. Dependency-free. Wave 3 #17.
 */
@Injectable({ providedIn: 'root' })
export class PosConfigSettingsService {
  model: any = {
    enableCustomerInputOnPurchase: false,
  };

  init(): boolean {
    return true;
  }

  setModel(model: any): void {
    this.model = model ? model : { enableCustomerInputOnPurchase: false };
  }

  getModel(): any {
    return this.model;
  }
}
